<template>
    <div class="csv-button relative" v-if="hasPermission">
        <vx-action-icon
            ref="csvButton"
            icon="DownloadIcon"
            is-button
            :tooltip="tooltip"
            color="warning"
            :disabled="isDisabled"
            :rounded="loading"
            @click="startConfirmation"
        />
        <vx-prompt
            :active.sync="confirming"
            title="Confirm"
            accept-text="Yes"
            @cancel="confirmed = false"
            @accept="confirmed = true"
        >
            <span>
                This report is approximately {{ this.approximateSizeText }}.
                <br />
                Please be mindful that large reports of this type, can be time consuming and
                resource intensive to generate.
                <br />
                Are you sure you want to continue?
            </span>
        </vx-prompt>
    </div>
</template>

<script>
export default {
    name: 'csv-button',
    props: {
        endpoint: {
            type: Function,
            required: true
        },
        filters: {
            type: Object,
            default: () => {}
        },
        currentResults: {
            type: Array
        },
        totalResults: {
            type: Number
        },
        fileName: {
            type: String
        }
    },
    data() {
        return {
            confirming: false,
            confirmed: null,
            largeReportSize: (2).megabytes()
        }
    },
    watch: {},
    computed: {
        hasResults() {
            return this.currentResults.any()
        },
        approximateSize() {
            if (!this.hasResults) {
                return 0
            }
            var currentResultCount = this.currentResults.length
            var resultSize = this.roughSizeOfObject(this.currentResults)
            var single = resultSize / currentResultCount
            var totalSize = single * this.totalResults
            return totalSize
        },
        approximateSizeText() {
            return this.approximateSize.asByteSize()
        },
        hasPermission() {
            return this.userHasRole(['CsvReportGenerator', 'SuperUser', 'Tester'])
        },
        isDisabled() {
            return this.loading || !this.hasResults || !this.hasPermission
        },
        isLargeReport() {
            return this.approximateSize < this.largeReportSize
        },
        tooltip() {
            if (!this.hasResults) {
                return 'No Results'
            }
            if (this.loading) {
                return 'Generating CSV'
            }
            if (!this.hasPermission) {
                return 'Requires Authorization'
            }

            return `Download as CSV (~${this.approximateSizeText})`
        }
    },
    methods: {
        async startConfirmation() {
            try {
                if (this.isLargeReport) {
                    this.exportToCsv()
                    return
                }
                this.confirming = true
                await this.watch('confirmed') // wait for the next set
                this.confirming = false

                if (this.confirmed == true) {
                    this.exportToCsv()
                }
            } finally {
                this.confirming = false
                this.confirmed = null
            }
        },
        async exportToCsv() {
            try {
                this.loading = true
                var min = this.delayFor(1000)
                var prom = this.endpoint(this.filters)
                var response = Promise.resolve()
                if (prom && prom.then) {
                    response = await prom
                }
                await Promise.all([min, response])
            } catch (error) {
                this.notifyServerError(error)
            } finally {
                this.loading = false
            }
        },
        roughSizeOfObject(object) {
            var objectList = []
            var stack = [object]
            var bytes = 0

            while (stack.length) {
                var value = stack.pop()
                if (value === null) {
                    continue
                }

                if (typeof value === 'boolean') {
                    // 10 for string true/false
                    bytes += 8
                } else if (typeof value === 'string') {
                    // js stores 2 bytes per char
                    bytes += value.length * 2
                } else if (typeof value === 'number') {
                    bytes += 12
                } else if (Array.isArray(value)) {
                    stack = stack.concat(value)
                } else if (typeof value === 'object' && !objectList.contains(value)) {
                    objectList.push(value)
                    Object.keys(value).forEach((key) => {
                        stack.push(value[key])
                    })
                }
            }
            return bytes / 1.3
        }
    },
    mounted() {},
    created() {}
}
</script>

<style lang="scss" scoped></style>
